import React, { FunctionComponent } from 'react';
import * as graphCMS from '../../../domain/graphcms';
import ArticleMarkdown from '../article-markdown/ArticleMarkdown';
import * as styles from './ArticleBlock.style';

export interface ArticleBlockProps extends graphCMS.ArticleBlock { }

export const headingTitleImportanceMapper: Record<graphCMS.HeadingTitleImportance, keyof JSX.IntrinsicElements> = {
  [graphCMS.HeadingTitleImportance.MEDIUM]: 'h3',
  [graphCMS.HeadingTitleImportance.HIGH]: 'h2',
};

const ArticleBlock: FunctionComponent<ArticleBlockProps> = ({
  id,
  title,
  content,
  headingTitleImportance,
}) => {
  const HeadingTitle = headingTitleImportanceMapper[headingTitleImportance] ?? headingTitleImportanceMapper.HIGH;

  return (
    <div
      css={styles.article}
    >
      <div
        id={id}
        css={styles.anchor}
      />
      <div css={styles.title}>
        <HeadingTitle>
          {title}
        </HeadingTitle>
      </div>
      <ArticleMarkdown>
        {content}
      </ArticleMarkdown>
    </div>
  );
};

export default ArticleBlock;
